import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-cc739aea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "¡Bienvenido a la sección de Retos!", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Disfruta del reto para afianzar conocimientos", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "cards" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { href: "#" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, null, -1))

import DefaultLayout from '@/layouts/DefaultLayout.vue';
import ProdevValidator from '@/components/auth/ProdevValidator.vue';
import ChallengeService from '@/services/ChallengeService';
import { onMounted,ref,Ref } from 'vue';
import ChallengeI from '@/interfaces/ChallengeInterface';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChallengeView',
  setup(__props) {

const loading= ref(false)
const service  = new ChallengeService()
const challenge:Ref<ChallengeI> = ref({})
onMounted(async()=>{
  loading.value = true; 
  challenge.value = await service.GetChallenge()
  loading.value =false;
})
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _createVNode(ProdevValidator),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("a", _hoisted_7, [
              _createElementVNode("img", {
                src: challenge.value?.image_url,
                alt: "challenge",
                class: "img-challens"
              }, null, 8, _hoisted_8),
              _createElementVNode("h4", null, _toDisplayString(challenge.value?.title), 1),
              _createElementVNode("h4", null, "Hashtag del reto: " + _toDisplayString(challenge.value?.sn_hashtag), 1),
              _createElementVNode("h4", null, "RRSS del reto: " + _toDisplayString(challenge.value?.sn_target), 1),
              _createElementVNode("div", {
                innerHTML: challenge.value?.description
              }, null, 8, _hoisted_9),
              _hoisted_10
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})